export enum ProductionChainFormFields {
  produceButtonId = "produceButtonId",
  isRejectUnassigned = "isRejectUnassigned",
}
